import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInsomniaComponent } from './simple-icons-insomnia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInsomniaComponent ],
    exports:      [ SimpleIconsInsomniaComponent ],
    bootstrap:    []
})
export class SimpleIconsInsomniaModule {}
